module.exports = __webpack_public_path__ + "media/images/zoom-plus-03cd09a9d0b98c087209f6596cfe4687.svg";